/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContactInfo
 */
export interface ContactInfo {
    /**
     * 
     * @type {string}
     * @memberof ContactInfo
     */
    phone: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactInfo
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactInfo
     */
    address: string | null;
}

/**
 * Check if a given object implements the ContactInfo interface.
 */
export function instanceOfContactInfo(value: object): value is ContactInfo {
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function ContactInfoFromJSON(json: any): ContactInfo {
    return ContactInfoFromJSONTyped(json, false);
}

export function ContactInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'phone': json['phone'],
        'email': json['email'],
        'address': json['address'],
    };
}

export function ContactInfoToJSON(value?: ContactInfo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'phone': value['phone'],
        'email': value['email'],
        'address': value['address'],
    };
}

